export default {
  NonVending: 'nonVending',
  Vending: 'vending',
  Inactive: 'inactive',
}
